// Gemeinsame Typen des Bereichs „Ideen“ (Server und Web).
/** Art eines Unterreiters: Ideen-Runde (Brainstorming mit der KI) oder Suche (Recherche). */
export const SITZUNG_ARTEN = ['ideen', 'suche'];
export const SITZUNG_ART_NAMEN = {
    ideen: 'Ideen-Runde',
    suche: 'Suche',
};
export const IDEE_STATUS = ['neu', 'festgehalten', 'verworfen'];
export const IDEE_STATUS_NAMEN = {
    neu: 'neu',
    festgehalten: 'festgehalten',
    verworfen: 'verworfen',
};
export const UEBERNAHME_NAMEN = {
    aufgabe: 'Aufgabe',
    mindmap: 'Mindmap-Punkt',
    budget: 'Kostenvorschlag',
    projekt: 'Projekt-Idee',
};
/** Punkte für die Sortierung nach Stimmen. */
export function ideePunkte(stimmen) {
    return stimmen.reduce((s, x) => s + x.wert, 0);
}
/** Betrag in Euro hübsch („1.250 €“). */
export function euro(betrag) {
    return `${betrag.toLocaleString('de-DE', { maximumFractionDigits: 2 })} €`;
}
//# sourceMappingURL=ideen.js.map